import app from '@/app';

/* @ngInject */
function Resource($resource, $http, $q) {
	const resource = $resource(
		'api/materialsServices/:id',
		{ id: '@id' },
		{
			create: { method: 'POST' },
			query: { method: 'GET' },
			update: { method: 'PUT' }
		}
	);
	return resource;
}

app.factory('MaterialsServices', Resource);
